import controller from './spinner.controller';

export default {
  bindings: {
    needToShow: '<',
    svgSize: '<?'
  },
  controller,
  template: require('./spinner.component.html')
};



// WEBPACK FOOTER //
// src/app/components/spinner/spinner.component.ts